import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface CTAButtonProps {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
}
export function CTAButton({
  children,
  className = '',
  onClick
}: CTAButtonProps) {
  const handleClick = () => {
    if (onClick) {
      onClick();
    } else {
      document.getElementById('pricing')?.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} onClick={handleClick} className={`group relative inline-flex items-center justify-center gap-2 rounded-full bg-cyan px-8 py-4 font-display font-bold text-dark transition-colors hover:bg-cyan-hover focus:outline-none focus:ring-2 focus:ring-cyan focus:ring-offset-2 focus:ring-offset-dark ${className}`} data-id="element-158">
      <span className="relative z-10 flex items-center gap-2 text-lg" data-id="element-159">
        {children}
        <ArrowRight className="h-5 w-5 transition-transform group-hover:translate-x-1" data-id="element-160" />
      </span>
      <div className="absolute inset-0 -z-10 rounded-full bg-cyan opacity-20 blur-xl transition-opacity group-hover:opacity-40" data-id="element-161" />
    </motion.button>;
}